'use client';

import Image, { type StaticImageData } from 'next/image';
import Marquee from 'react-fast-marquee';
import { useReducedMotion } from '@/hooks/use-reduced-motion';
import imageAsito from '../public/img/logos/asito.png';
import imageDnata from '../public/img/logos/dnata.png';
import imageGeodis from '../public/img/logos/geodis.png';
import imageHMS from '../public/img/logos/hms.png';
import imageJobair from '../public/img/logos/jobair.png';
import imageKLM from '../public/img/logos/klm.png';
import imageMenzies from '../public/img/logos/menzies.png';
import imageSchiphol from '../public/img/logos/schiphol.png';
import imageSwissport from '../public/img/logos/swissport.png';
import imageUPS from '../public/img/logos/ups.png';

const logos: StaticImageData[] = [
    imageMenzies,
    imageKLM,
    imageJobair,
    imageUPS,
    imageHMS,
    imageSwissport,
    imageSchiphol,
    imageAsito,
    imageGeodis,
    imageDnata,
];

export default function CompanyLogos() {
    const reduced = useReducedMotion();

    return (
        <>
            <div className="-mx-5 md:hidden">
                <Marquee gradient={false} pauseOnHover={false} autoFill={true} play={!reduced} className="w-full">
                    {logos.map((logo) => (
                        <div
                            key={logo.src}
                            className="relative shrink-0 h-[100px] aspect-[26/15]"
                        >
                            <Image
                                src={logo}
                                sizes="(min-width: 768px) 250px, 173px"
                                className="size-full object-contain"
                                alt=""
                            />
                        </div>
                    ))}
                </Marquee>
            </div>

            <div className="hidden md:flex items-center gap-0 w-full flex-wrap justify-center max-w-[1000px]">
                {logos.map((logo) => (
                    <div
                        key={logo.src}
                        className="relative shrink-0 w-full max-w-[250px] aspect-[26/15]"
                    >
                        <Image
                            src={logo}
                            sizes="(min-width: 768px) 250px, 173px"
                            className="size-full object-contain"
                            alt=""
                        />
                    </div>
                ))}
            </div>
        </>
    );
}
